import React, {
	//useState,
	//useEffect,
	//useMemo,
} from 'react';
import { GenericListSelect } from './genericListSelect';

export const BreedTypeSelect = (props) => {
	const types = ['British', 'Euro', 'British x Euro','Bos Indicus','British x Bos Indicus', 'Euro x Bos Indicus', 'Composite', 'Dairy']

	return (
		<>
			<GenericListSelect
				id = 'BreedType'
				label = 'Breed'
				dataArray = { types }
				cols = { props.cols }
				controlStyle = { props.controlStyle }
				handleChange = {(evt) => props.handleChange(evt)}
				value = { props.value }
				required = { props.required }
				//pattern = {'^\d+$'}	// integer
				pattern = {'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
				invalidMsg = 'Select a Breed type!'
				lock = { props.lock }
			/>
		</>
	)

}